"use client";

/**
 * The FAQ page's questions and answers in two columns. The other FAQ studies stay on the
 * concept board (concept/groups/faq.tsx).
 */

import { DISPLAY } from "@/components/editorial";
import { FAQS } from "@/lib/faqs";

/* ================================================================= */
/*  FAQ-002 — static two-column Q&A                                   */
/* ================================================================= */

export function TwoColumnQa() {
  return (
    <dl className="grid gap-x-12 gap-y-10 md:grid-cols-2 md:gap-x-14">
      {FAQS.map((item) => (
        <div
          key={item.q}
          className="border-t border-[color-mix(in_srgb,var(--theme-ink)_18%,transparent)] pt-5"
        >
          <dt
            className="text-[1.15rem] font-semibold leading-[1.3] tracking-[-0.01em] text-[var(--theme-ink)] md:text-[1.25rem]"
            style={DISPLAY}
          >
            {item.q}
          </dt>
          <dd className="m-0 mt-3 space-y-4 max-w-[52ch] text-[0.98rem] leading-[1.6] text-[color-mix(in_srgb,var(--theme-ink)_88%,transparent)]">
            {item.a.split("\n\n").map(paragraph => <p key={paragraph}>{paragraph}</p>)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
